/**
 * DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント
 * ABテスト振分け用グループ種別
 */
export type TopResumeScoreFilteringType =
  | keyof typeof TOP_RESUME_SCORE_FILTERING_LINK_NAMES
  | 'EXCLUDED';

/**
 * DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント
 * レコメンド種別
 */
export const TOP_RESUME_SCORE_FILTERING_RECOMMEND_TYPE =
  'AWS_Recommend_oubo_tsuuka';

/**
 * DODASITE-792_書類通過スコア0.05以下の足切り×通過注力セグメント
 * imp計測時のLinkName
 */
export const TOP_RESUME_SCORE_FILTERING_LINK_NAMES = {
  ORIGINAL: 'ori_tsuukaseg0.05',
  TEST_B: 'test2_tsuukaseg0.05',
  TEST_C_APPLICANT: 'test3_tsuukaseg0.05',
  TEST_C_PASSER: 'test4_tsuukaseg0.05',
} as const;

/**
 * ABテスト対象外
 */
export const NON_TARGET_AB_TEST = '0';
